import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'
export default class DraftMeetingID {
    constructor(public readonly value: number) {
        ensureNoUndefinedProperties(this)
    }
}
